import { PlayCircleOutlineRounded } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useMemo } from "react";
import { useStyles } from "./styles";

type FormatImageProps = {
  title: string;
  subtitle?: string;
  image: string;
  isVideo?: boolean;
  onClick?: () => void;
};

export function FormatImage({
  onClick,
  title,
  subtitle,
  isVideo,
  image = "https://datasalesio-imagens.s3.amazonaws.com/empty_image_propaganda_02.png",
}: FormatImageProps) {
  const styles = useStyles();

  const altImage = useMemo(() => {
    return `image-${title}`;
  }, [title]);

  return (
    <Stack onClick={onClick} spacing={1} sx={{ cursor: "pointer" }}>
      <div className={styles.root}>
        {isVideo && (
          <div className={styles.contentBtnVideo}>
            <PlayCircleOutlineRounded fontSize="large" />
          </div>
        )}
        <img className={styles.image} src={image} alt={altImage} />
      </div>
      <Stack spacing={1} direction="row">
        <Typography fontWeight={500}>{title}</Typography>
        {isVideo && <Chip size="small" color="primary" label="Vídeo" />}
      </Stack>
      {subtitle && (
        <Typography variant="body2" color="GrayText">
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
